// 风控接口路径常量
export const RISK_CONTROL_API_PATH = 'gop.alipic.icirena.own';